import _ from 'lodash';
import api from '@/services/api/index';

import {
  LOAD_INFRASTRUKTURSTATI,
  LOAD_INFRASTRUKTURTYPEN,
  LOAD_INFRASTRUKTURGRUPPEN,
  LOAD_KATEGORIEN,
  LOAD_INFRASTRUKTURSUBSTATI,
  LOAD_STANDORTE,
  LOAD_ANZAHL_INFRASTRUKTUR,
} from './actions.type';

import {
  SET_INFRASTRUKTURSTATI,
  SET_INFRASTRUKTURSTATI_LOADED,
  SET_INFRASTRUKTURTYPEN,
  SET_INFRASTRUKTURTYPEN_LOADED,
  SET_INFRASTRUKTURGRUPPEN,
  SET_INFRASTRUKTURGRUPPEN_LOADED,
  SET_INFRASTRUKTURSUBSTATI,
  SET_INFRASTRUKTURSUBSTATI_LOADED,
  SET_STANDORTE,
  SET_STANDORTE_LOADED,
  SET_ANZAHL_INFRASTRUKTUR,
} from './mutations.type';

import historie from './historie';
import { INFRASTRUKTURBAU_SUBSTATI } from './getters.type';

function flattenNestedArray(arr) {
  const result = [];

  function recurse(items) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of items) {
      // Objekt ohne childs kopieren, damit keine Referenzen bleiben
      const { childs, ...rest } = item;
      result.push(rest);

      if (Array.isArray(childs) && childs.length > 0) {
        recurse(childs);
      }
    }
  }

  recurse(arr);
  return result;
}

export default {
  namespaced: true,
  state: {
    infrastrukturstati: [],
    infrastrukturstati_loaded: false,
    infrastruktursubstati: [],
    infrastruktursubstati_loaded: false,
    infrastrukturtypen: [],
    _infrastrukturtypen_loaded: false,
    infrastrukturgruppen: [],
    infrastrukturgruppenFlat: [],
    _infrastrukturgruppen_loaded: false,
    standorte: [],
    standorteFlat: [],
    _standorte_loaded: false,
    anzahl_infrastruktur: null,
  },
  mutations: {
    [SET_INFRASTRUKTURSTATI](state, val) {
      state.infrastrukturstati = val;
    },
    [SET_INFRASTRUKTURSTATI_LOADED](state, val) {
      state.infrastrukturstati_loaded = val;
    },
    [SET_INFRASTRUKTURSUBSTATI](state, val) {
      state.infrastruktursubstati = val;
    },
    [SET_INFRASTRUKTURSUBSTATI_LOADED](state, val) {
      state.infrastruktursubstati_loaded = val;
    },
    [SET_INFRASTRUKTURTYPEN](state, val) {
      state.infrastrukturtypen = val;
    },
    [SET_INFRASTRUKTURTYPEN_LOADED](state, val) {
      state.infrastrukturtypen_loaded = val;
    },
    [SET_INFRASTRUKTURGRUPPEN](state, val) {
      state.infrastrukturgruppen = val;
      state.infrastrukturgruppenFlat = flattenNestedArray(val);
    },
    [SET_INFRASTRUKTURGRUPPEN_LOADED](state, val) {
      state.infrastrukturgruppen_loaded = val;
    },
    [SET_STANDORTE](state, val) {
      state.standorte = val;
      state.standorteFlat = flattenNestedArray(val);
    },
    [SET_STANDORTE_LOADED](state, val) {
      state.standorte_loaded = val;
    },
    [SET_ANZAHL_INFRASTRUKTUR](state, val) {
      state.anzahl_infrastruktur = val;
    },
  },
  actions: {
    async [LOAD_INFRASTRUKTURSTATI]({ commit, state }, force = false) {
      if (state.infrastrukturstati_loaded && !force) {
        return state.infrastrukturstati;
      }
      const response = await api.v1.infrastruktur.status.get();
      commit(SET_INFRASTRUKTURSTATI, response.data);
      commit(SET_INFRASTRUKTURSTATI_LOADED, true);
      return response.data;
    },
    async [LOAD_INFRASTRUKTURSUBSTATI]({ commit, state }, force = false) {
      if (state.infrastruktursubstati_loaded && !force) {
        return state.infrastruktursubstati;
      }
      const response = await api.v1.infrastruktur.status.getSubStati();
      commit(SET_INFRASTRUKTURSUBSTATI, response.data);
      commit(SET_INFRASTRUKTURSUBSTATI_LOADED, true);
      return response.data;
    },
    async [LOAD_INFRASTRUKTURTYPEN]({ commit, state }, force = false) {
      if (state.infrastrukturtypen_loaded && !force) {
        return state.infrastrukturtypen;
      }
      const response = await api.v1.infrastruktur.typ.get();
      commit(SET_INFRASTRUKTURTYPEN, response.data);
      commit(SET_INFRASTRUKTURTYPEN_LOADED, true);
      return response.data;
    },
    async [LOAD_INFRASTRUKTURGRUPPEN]({ commit, state }, force = false) {
      if (state.infrastrukturgruppen_loaded && !force) {
        return state.infrastrukturgruppen;
      }
      const response = await api.v1.infrastruktur.gruppe.get();
      commit(SET_INFRASTRUKTURGRUPPEN, response.data);
      commit(SET_INFRASTRUKTURGRUPPEN_LOADED, true);
      return response.data;
    },

    async [LOAD_STANDORTE]({ commit, state }, force = false) {
      if (state.standorte_loaded && !force) {
        return state.standorte;
      }
      const response = await api.v1.infrastruktur.standort.get();
      commit(SET_STANDORTE, response.data);
      commit(SET_STANDORTE_LOADED, true);
      return response.data;
    },

    async [LOAD_ANZAHL_INFRASTRUKTUR]({ commit }) {
      const response = await api.v1.infrastruktur.getAnzahl();
      commit(SET_ANZAHL_INFRASTRUKTUR, response.data);
      return response.data;
    },

    async [LOAD_KATEGORIEN]({ dispatch }) {
      await Promise.all([
        dispatch(LOAD_INFRASTRUKTURSTATI),
        dispatch(LOAD_INFRASTRUKTURSUBSTATI),
        dispatch(LOAD_INFRASTRUKTURTYPEN),
        dispatch(LOAD_INFRASTRUKTURGRUPPEN),
        dispatch(LOAD_STANDORTE),
      ]);
    },
  },
  modules: {
    historie,
  },
  getters: {
    [INFRASTRUKTURBAU_SUBSTATI](state) {
      return _.chain(state.infrastruktursubstati).filter((e) => e.infrastrukturbau === true).sortBy((e) => e.sort).value();
    },
  },
};
